import { render } from "./App.vue?vue&type=template&id=db151028&lang=pug"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=db151028&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__